import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BusinessContext = createContext(null);

export function BusinessProvider({ children }) {
  const { user } = useAuth();
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  const isBusiness = user && (user.role === "manager" || user.role === "agent");

  const refresh = useCallback(async () => {
    if (!isBusiness) {
      setBusiness(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/business");
      setBusiness(data);
    } catch {
      setBusiness(null);
    } finally {
      setLoading(false);
    }
  }, [isBusiness]);

  useEffect(() => {
    setLoading(true);
    refresh();
  }, [refresh]);

  const updateBusiness = async (patch) => {
    const { data } = await api.put("/business", patch);
    setBusiness(data);
    return data;
  };

  return (
    <BusinessContext.Provider value={{ business, loading, refresh, updateBusiness, setBusiness }}>
      {children}
    </BusinessContext.Provider>
  );
}

export const useBusiness = () => useContext(BusinessContext);
